import React from 'react';
import Header from '../components/Header';
import Footer from "../components/Footer";
import { Helmet } from 'react-helmet';

export const Aboutus = () => {
  const pageTitle = "About Us";

  return (
     


    <div>
     <Helmet>
        <title>{pageTitle}</title>
        
      </Helmet> 

       <div class="main-content">
       <Header/>
  <section className="banner">
    <div className="container">
      <div className="about-text2">
      </div>
    </div>
  </section>
  <div className="container">
    <div className="row">
      <div className="col-md-12 col-md-6 wow animate__animated animate__fadeInUp">
        <div className="about-section">
          <h2>Company With a Purpose</h2>
          <p>Our Company partners with various developers to market and sell their residential and commercial properties. Our Company enters into mandates with the developers, securing exclusive or semi-exclusive rights to sell their inventories in return for brokerage income. To obtain such exclusive mandates, our Company pays an advance to the developer, which is retained as a deposit by such developer and refunded to our Company upon successful completion of the mandate or upon expiry of its tenure. Such arrangement provides our Company with enhanced revenue visibility and business stability. By collaborating with the developers, our Company ensures timely realization of revenue and reinforces its position as a credible and trusted long-term partner in the real estate sector.</p>
          <p>In addition to partnering with real estate developers, our Company also collaborates closely with our Group Entities namely, Aurika Homes Private Limited & Aurika Projects LLP, to facilitate the sale of projects developed by such Group Entities. Our Company has entered into Memorandum of Understanding (MoU) dated June 20, 2024 and March 15, 2025 with our Group Entities namely, Aurika Homes Private Limited & Aurika Projects LLP, respectively, securing exclusive rights to market and sell their projects in return for brokerage income. This arrangement enables us to leverage our market expertise, strengthen synergies within the group, and derive mutual benefits from the established relationship with such Group Entities.</p>
          <p>Our Company leverages a strong network of over 200 brokers, enabling it to expand its addressable market and strengthen its business outreach. These brokers play a vital role in supporting our Company’s sales efforts and overall business growth. Additionally, our Company utilizes it’s social media platforms such as Facebook and search engines like Google to market developers’ inventories and enhance visibility.</p>
          <p>Our Company is a promoter driven real estate services company engaged in providing a wide range of real estate solutions, including brokerage, property advisory, loan syndication, and project management service. Our Company has also expanded its operations into the real estate development segment, through investment in our Group Entities, Aurika Developers LLP and Black Opal Ventures LLP.</p>
          <p>Our Company operates across the residential and commercial property segments, offering solutions to a diverse clientele, including real estate developers, retail buyers/sellers, and investors, across both residential and commercial segments. Our primary focus lies in newly constructed/ under- construction properties, where we support developers in marketing and selling their projects while assisting customers in property acquisition.</p>
          <p>Our Promoter and Managing Director, Mr. Prasoon Chauhan is an entrepreneur with 18+ years of experience in scaling businesses in the real estate and banking sectors. He holds a Post Graduate Diploma in Executive Management and brings strategic insight and operational expertise to our Company. As the founder of the Company, he has been instrumental in establishing our Company as a strategic advisory and consulting platform, driving its growth and expanding its service offerings across diverse real estate segments. His expertise in business development, strategic planning, and operational execution has enabled our Company to build strong partnerships with Real-Estate Developers, deliver end-to-end solutions, and establish a notable presence in the market.</p>
          <p>Leveraging our domain expertise, professional management, and client-centric approach, our Company aims to build a platform for delivering integrated real estate solutions, while contributing to the evolving needs of India's real estate ecosystem through our wholly owned subsidiary i.e., Black Opal Technologies Private Limited.</p>

          <h3 style={{ marginTop: 30, color: '#f26624' }}>Our Philosophy and Pillars</h3>
          <p>Our Company was established with the aim of improving the real estate transaction process by emphasizing efficiency, clarity, and quality of service. Our operations are guided by our core pillars:</p>
          <ul style={{ listStyleType: 'disc', paddingLeft: 25, marginBottom: 20 }}>
            <li style={{ marginBottom: 6 }}>People</li>
            <li style={{ marginBottom: 6 }}>Process</li>
            <li style={{ marginBottom: 6 }}>Technology</li>
          </ul>
          <p>Our focus has always been on the people who we work with, our employees, our business partners, our customers and our investors, ensuring transparency and quality service with simple well-defined processes and using technology to bridge gaps for effective service delivery.</p>

          <h3 style={{ marginTop: 30, color: '#f26624' }}>Our Vision</h3>
          <p>To be a trusted and leading real estate brokerage partner, bridging developers and buyers through transparent, value-driven, and customer-focused property solutions.</p>

          <h3 style={{ marginTop: 30, color: '#f26624' }}>Our Mission</h3>
          <p>Customer Empowerment- We achieve this through smart tools, perfect match-making. Bid farewell to buying confusions!</p>

          {/* <h3 style={{ marginTop: 30, color: '#f26624' }}>OUR SERVICES</h3> */}
          {/* <p>Our Company’s core service offerings comprise brokerage services derived from exclusive sales mandates or inventory underwriting arrangements. Under this model, our Company enters into agreements with real estate developers, securing exclusive or semi-exclusive rights to market and sell specific units within a project in return for brokerage income. To obtain these rights, our Company provides an advance to the developer, which is refunded upon the sale of the allotted inventory or upon expiry of the mandate period. The brokerage is generally determined based on a predefined slab structure. This arrangement is commonly referred to as inventory underwriting.</p>
          <p>Additionally, during Fiscal 2025, the Company earned revenue of ₹200.00 lakhs from loan syndication activities. Furthermore, our Company continues to explore opportunities to diversify its revenue streams and enhance value delivery to its customers.</p>
          <p>In support of its core business operations, our Company provides strategic advisory services to real estate developers, encompassing product positioning, pricing strategy, market research, and inventory structuring. These value-added services are aimed at enhancing sales velocity and improving market penetration. While our Company does not earn direct revenue from such services, they play a crucial role in strengthening its relationships with the developers and their retention by offering a comprehensive range of solutions under one roof.</p>
          <p>Our Company operates on a multi-stakeholder engagement model, monetizing through:</p>
          <ul style={{ listStyleType: 'disc', paddingLeft: 25, marginBottom: 20 }}>
            <li style={{ marginBottom: 10 }}><b>Brokerage for Exclusive Sale Arrangements:</b> Brokerage or Commission margin on the sale of underwritten/exclusively mandated inventories.</li>
            <li style={{ marginBottom: 10 }}><b>Loan Syndication Services &amp; Advisory:</b> Commission or success fees for arranging developer and buyer financing and providing advisory and consulting services in primary market.</li>
            <li style={{ marginBottom: 10 }}><b>Real Estate Development:</b> Investment in Real Estate Development business through Group Entities operating in Tier -II cities in India.</li>
          </ul> */}
        </div>
      </div>
    </div>
  </div>

  <section className="ourteam">
    <div className="team style1 team-style1  pb-100 md-pt-70 md-pb-70">
      <div className="bo">
        <h2>Our Growth Catalysts</h2>
        <p>Meet our growth catalyst, the dynamic leadership team driving our success.</p>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="tabs-ourteam">
            <input type="radio" name="tabs" id="tabone" defaultChecked="checked" />
            <label htmlFor="tabone">Board of Directors</label>
            <div className="tab">
              <div className="tab-content" id="v-pills-tabContent" style={{marginTop: 5}}>
                <div className="tab-pane fade pt-4 me-4 active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                  <div className="accordion" id="accordionPanelsStayOpenExample">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.2s', animationName: 'fadeInUp'}}>
                          <div className="team-wrap">
                            <div className="image-wrap">
                              <a href="#" datacls-bs-toggle="modal" data-bs-target="#exampleModal"><img src="assets/img/prasoon-ceo.png" alt="Founder & CEO, Blackopal Group" /></a>
                            </div>
                            <div className="team-content">
                              <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#exampleModal">Prasoon
                                  Chauhan</a></h3>
                              <span className="team-title">Founder &amp; M.D</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.2s', animationName: 'fadeInUp'}}>
                          <div className="team-wrap ourteam-m-t-b">
                            <div className="image-wrap">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#ishanModal"><img src="assets/img/Afreen Ahmad3.png" width={155} height={155} alt="Team" /></a>
                            </div>
                            <div className="team-content">
                              <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#ishanModal">Sheikh Arfeen Ahmed 
                                </a></h3>
                              <span className="team-title">Non-Executive Director
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.1s', animationName: 'fadeInUp'}}>
                          <div className="team-wrap">
                            <div className="image-wrap">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#priyaModal"><img src="assets/img/Sandeep_1.png" width={155} height={155} alt="Team" /></a>
                            </div>
                            <div className="team-content">
                              <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#priyaModal">Sandeep Kumar Singh 
                                </a></h3>
                              <span className="team-title">Non-Executive Director</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-5">
                        <div className="col-lg-4 offset-lg-2 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.11s', animationName: 'fadeInUp'}}>
                          <div className="team-wrap ">
                            <div className="image-wrap">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#gauravModal"><img src="assets/img/Sangeeta_1.png" width={155} height={155} alt="Head - Business & Strategy" /></a>
                            </div>
                            <div className="team-content">
                              <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#gauravModal">Sangeeta Bhatia 
                                </a></h3>
                              <span className="team-title">Independent Director
                              </span>
                             
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-lg-4 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.1s', animationName: 'fadeInUp'}}>
                          <div className="team-wrap ourteam-m-t-b">
                            <div className="image-wrap ourteam-m-t-b">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#auModal"><img src="assets/img/ashutosh.png" alt="Team" /></a>
                            </div>
                            <div className="team-content">
                              <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#auModal">Ashutosh Kaithwar
                                </a></h3>
                              <span className="team-title">Head – Product
                              </span>
                              <span className="team-title "> Technology
                                Services </span>
                            </div>
                          </div>
                        </div> */}
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.1s', animationName: 'fadeInUp'}}>
                          <div className="team-wrap">
                            <div className="image-wrap">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#KanvModal"><img src="assets/img/Pradeep_1.png" width={155} height={155} alt="Team" /></a>
                            </div>
                            <div className="team-content">
                              <h3 className="team-name"><a data-bs-toggle="modal" data-bs-target="#KanvModal">Pradeep Pasari </a></h3>
                              <span className="team-title">Independent Director</span>
                              
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="row mt-5">
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp offset-md-4" style={{animationDelay: '0.1s', animationName: 'fadeInUp'}}>
                          <div className="team-wrap">
                            <div className="image-wrap">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#lokeshModal"><img src="assets/img/lokesh.png" alt="Team" /></a>
                            </div>
                            <div className="team-content">
                              <h3 className="team-name"><a href="#lokeshModal">Lokesh Ahuja</a></h3>
                              <span className="team-title">Director</span>
                              <span className="team-title ">Advisory
                                Services</span>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <input type="radio" name="tabs" id="tabtwo" />
            <label htmlFor="tabtwo">KMP & SMP</label>
            {/* <div className="tab">
              <div className="tab-content" id="v-pills-tabContent" style={{marginTop: 5}}>
                <div className="tab-pane fade pt-4 me-4 active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                  <div className="accordion" id="accordionPanelsStayOpenExample">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.2s', animationName: 'fadeInUp'}}>
                          <div className="team-wrap">
                            <div className="image-wrap">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#mandeepModal"><img src="assets/img/Mandeep.png" alt /></a>
                            </div>
                            <div className="team-content">
                              <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#mandeepModal">Mandeep Singh Sobti</a></h3>
                              <span className="team-title"> Founder &amp; CEO- Sobtax, NY Inc &amp; 88 Gerard Associates LLC</span>   
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.2s', animationName: 'fadeInUp'}}>
                          <div className="team-wrap ourteam-m-t-b">
                            <div className="image-wrap">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#rakeshModal"><img src="assets/img/rakesh.png" alt="Team" /></a>
                            </div>
                            <div className="team-content">
                              <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#rakeshModal">Rakesh Agarwal
                                </a></h3>
                              <span className="team-title">Ex-CEO, Dalmia Group Holdings
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.1s', animationName: 'fadeInUp'}}>
                          <div className="team-wrap">
                            <div className="image-wrap">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#amitModal"><img src="assets/img/amit.png" alt="Team" /></a>
                            </div>
                            <div className="team-content">
                              <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#amitModal">Amit Sehgal
                                </a></h3>
                              <span className="team-title">Founder - Pharynxai at PharynxAI</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.1s', animationName: 'fadeInUp'}}>
                        <div className="team-wrap ourteam-m-t-b">
                            <div className="image-wrap">
                              <a href="#" data-bs-toggle="modal" data-bs-target="#pradeepModal"><img src="assets/img/Pradeep.png" alt="Team" /></a>
                            </div>
                            <div className="team-content">
                              <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#pradeepModal">Pradeep Pasari
                                </a></h3>
                              <span className="team-title">Ex- Finance & Accounts, Narotam Sekhsaria Family Office (NSFO)</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="tab">
    <div className="tab-content" id="v-pills-tabContent" style={{marginTop: 5}}>
        <div className="tab-pane fade pt-4 me-4 active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
            <div className="accordion" id="accordionPanelsStayOpenExample">
                <div className="container">
                    <div className="row justify-content-center !gap-20">
                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.2s', animationName: 'fadeInUp'}}>
                            <div className="team-wrap">
                                <div className="image-wrap">
                                    <a href="#" data-bs-toggle="modal" data-bs-target="#mandeepModal"><img src="assets/img/gaurav.png" alt /></a>
                                </div>
                                <div className="team-content">
                                    <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#mandeepModal">Gaurav Bhardwaj </a></h3>
                                    <span className="team-title">Chief Financial Officer</span>   
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.2s', animationName: 'fadeInUp'}}>
                            <div className="team-wrap ourteam-m-t-b">
                                <div className="image-wrap">
                                    <a href="#" data-bs-toggle="modal" data-bs-target="#rakeshModal"><img src="assets/img/Anju.jpeg" alt="Team" style={{ width: 155, height: 155, borderRadius: "50%", objectFit: "cover", objectPosition: "center top" }} /></a>
                                </div>
                                <div className="team-content">
                                    <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#rakeshModal">Anju </a></h3>
                                    <span className="team-title">Company Secretary & Compliance Officer</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.1s', animationName: 'fadeInUp'}}>
                            <div className="team-wrap">
                                <div className="image-wrap">
                                    <a href="#" data-bs-toggle="modal" data-bs-target="#amitModal"><img src="assets/img/kanav.png" alt="Team" /></a>
                                </div>
                                <div className="team-content">
                                    <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#amitModal">Kanv Bhalla </a></h3>
                                    <span className="team-title">Senior Managerial Personnel</span>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 wow animate__animated animate__fadeInUp " style={{animationDelay: '0.1s', animationName: 'fadeInUp'}}>
                            <div className="team-wrap ourteam-m-t-b">
                                <div className="image-wrap">
                                    <a href="#" data-bs-toggle="modal" data-bs-target="#pradeepModal"><img src="assets/img/Pradeep.png" alt="Team" /></a>
                                </div>
                                <div className="team-content">
                                    <h3 className="team-name"><a href="#" data-bs-toggle="modal" data-bs-target="#pradeepModal">Pradeep Pasari</a></h3>
                                    <span className="team-title">Family Office Advisory Professional</span>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

          </div>
        </div>
      </div>
    </div>
  </section>
 <Footer/>

  </div>
<div>



  <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog ">
      <div className="modal-content modal-xl">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel" />
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          <div className="rs-contact contact-style2 md-pt-70 md-pb-70">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="container custom">
                    <div className="btm-info-team">
                      <div className="row align-items-center">
                        <div className="col-lg-3 md-mb-50">
                          <div className="images-part">
                            <img src="assets/img/prasoon-ceo.png" alt="images" />
                          </div>
                        </div>
                        <div className="col-lg-9">
                          <div className="con-info">
                            <h4>Prasoon Chauhan</h4>
                            <p>Founder &amp; M.D, Blackopal Group</p>
                            <div className="ps-informations">
                            </div>
                            <div className="short-desc">
                              <p>Prasoon Chauhan, is the Promoter, Managing Director, and Founder of our Company. He holds a Post Graduate Diploma in Executive Management from the Institute of Management Technology and a Bachelor of Arts degree from the University of Allahabad. He has also successfully completed the Junior Associate of the Indian Institute of Bankers (JAIIB) examination conducted by the Indian Institute of Banking and Finance.</p>
                              <p>Mr. Chauhan has over eighteen years of diverse experience spanning banking, real estate, and financial consulting. He began his career with Yes Bank Limited, where he served for around 10 years before demitting office in May 2017. Subsequently, he joined ATS Homekraft, the real estate development arm of ATS Group, as Chief Executive Officer, where he served from May 2017 to July 2020.</p>
                              <p>In September 2020, he founded Black Opal Consultants Limited, a company engaged in providing real estate brokerage services by facilitating the sale of properties in return for brokerage income. Under his leadership, the Company has demonstrated consistent growth and strengthened its position in the real estate brokerage segment.</p>
                              <p>Mr. Chauhan’s extensive experience in financial services, infrastructure, and real estate sectors, coupled with his entrepreneurial vision and leadership acumen, has been instrumental in shaping the strategic direction and growth plans of our Company.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="modal fade" id="ishanModal" tabIndex={-1} aria-labelledby="ishanModalLabel" aria-hidden="true">
    <div className="modal-dialog ">
      <div className="modal-content modal-xl">
        <div className="modal-header">
          <h5 className="modal-title" id="ishanModalLabel" />
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          <div className="rs-contact contact-style2 md-pt-70 md-pb-70">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="container custom">
                    <div className="btm-info-team">
                      <div className="row align-items-center">
                        <div className="col-lg-3 md-mb-50">
                          <div className="images-part">
                            <img src="assets/img/Afreen Ahmad3.png" width={150} height={150} alt="images" />
                          </div>
                        </div>
                        <div className="col-lg-9">
                          <div className="con-info">
                            <h4>Sheikh Arfeen Ahmed
                            </h4>
                            <p>Non-Executive Director
                            </p>
                            <div className="short-desc">
                              <p>Sheikh Arfeen Ahmed, is a Non-Executive Director of our Company and has been serving on the Board since February 14, 2025. He holds a Bachelor of Commerce (Hons.) degree from Delhi University and has completed a two-year full-time course in Planning and Entrepreneurship from The Indian Institute of Planning &amp; Management, Delhi. He has over 7 years of experience in real estate, banking, and investment property consultancy, with expertise in sales, business planning, and financial services. He is founder of one of our group entity Grabhome Consulting Private Limited which is into Real Estate Brokerage and Consultancy business and work closely with our company. He has joined our Company in February 2025.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="modal fade" id="priyaModal" tabIndex={-1} aria-labelledby="priyaModalLabel" aria-hidden="true">
    <div className="modal-dialog ">
      <div className="modal-content modal-xl">
        <div className="modal-header">
          <h5 className="modal-title" id="priyaModalLabel" />
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          <div className="rs-contact contact-style2 md-pt-70 md-pb-70">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="container custom">
                    <div className="btm-info-team">
                      <div className="row align-items-center">
                        <div className="col-lg-3 md-mb-50">
                          <div className="images-part">
                            <img src="assets/img/Sandeep_1.png" width={150} height={150} alt="images" />
                          </div>
                        </div>
                        <div className="col-lg-9">
                          <div className="con-info">
                            <h4>Sandeep Kumar Singh
                            </h4>
                            <p>Non-Executive Director
                            </p>
                            <div className="short-desc">
                              <p>Sandeep Kumar Singh, is the Non-Executive Director of our Company. He holds an MBA in Marketing from Chaudhary Charan Singh University, Meerut and B.Sc. from Rohilkhand University, Bareilly. He has over 22 years of experience in business operations, sales, liasoning, supply chain management, and customer relationship management, having previously worked with leading organizations such as Reliance Jio, Idea Cellular, Britannia etc. He joined our Company in October 2024 and plays a key role in overseeing operations, channel coordination, and strategic execution.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="modal fade" id="gauravModal" tabIndex={-1} aria-labelledby="gauravModalLabel" aria-hidden="true">
    <div className="modal-dialog ">
      <div className="modal-content modal-xl">
        <div className="modal-header">
          <h5 className="modal-title" id="gauravModalLabel" />
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          <div className="rs-contact contact-style2 md-pt-70 md-pb-70">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="container custom">
                    <div className="btm-info-team">
                      <div className="row align-items-center">
                        <div className="col-lg-3 md-mb-50">
                          <div className="images-part">
                            <img src="assets/img/Sangeeta_1.png" width={150} height={150} alt="images" />
                          </div>
                        </div>
                        <div className="col-lg-9">
                          <div className="con-info">
                            <h4>Sangeeta Bhatia
                            </h4>
                            <p>Independent Director
                            </p>
                            <div className="short-desc">
                              <p>Sangeeta Bhatia, is an Independent Director of our Company, appointed to the Board on April 30, 2025. She holds Bachelor of Science degree from Delhi University and a Post Graduate Diploma in International Trade from Punjab University. She became a member of The Council of Chartered Financial Analysts with effect from September 15, 1998. She has around 36 years of experience with NTPC Limited, where she superannuated as the Executive Director (Finance). During her tenure, she also served on the Boards of Six NTPC Group companies. She is registered with the Indian Institute of Corporate Affairs as an Independent Director.</p>
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="modal fade" id="auModal" tabIndex={-1} aria-labelledby="auModalLabel" aria-hidden="true">
    <div className="modal-dialog ">
      <div className="modal-content modal-xl">
        <div className="modal-header">
          <h5 className="modal-title" id="auModalLabel" />
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          <div className="rs-contact contact-style2 md-pt-70 md-pb-70">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="container custom">
                    <div className="btm-info-team">
                      <div className="row align-items-center">
                        <div className="col-lg-3 md-mb-50">
                          <div className="images-part">
                            <img src="assets/img/ashutosh.png" alt="images" />
                          </div>
                        </div>
                        <div className="col-lg-9">
                          <div className="con-info">
                            <h4>Ashutosh Kaithwar
                            </h4>
                            <p>Head – Product
                            </p>
                            <div className="short-desc">
                              <p>An ISB alumnae with B. Tech from HBTI, having 10+
                                Years of experience in Corporate Strategy,
                                Consulting, and Valuation in the Core Real Estate
                                Industry. Having worked as North Head- Advisory
                                Services in Knightfrank, ATS Group, Brigade Group,
                                etc. </p>
                              <p> He is a tech-savvy professional having proven
                                deliverables in Strategizing complex business
                                problems. His logic-driven technical abilities make
                                him an excellent lead to build and scale the product
                                envisaged. In his free time he loves to explore
                                different coding languages, he is already a
                                certified python coder with machine learning
                                abilities.</p>
                              <p>He Heads the Product and technology development
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="modal fade" id="KanvModal" tabIndex={-1} aria-labelledby="KanvModalLabel" aria-hidden="true">
    <div className="modal-dialog ">
      <div className="modal-content modal-xl">
        <div className="modal-header">
          <h5 className="modal-title" id="KanvModalLabel" />
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          <div className="rs-contact contact-style2 md-pt-70 md-pb-70">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="container custom">
                    <div className="btm-info-team">
                      <div className="row align-items-center">
                        <div className="col-lg-3 md-mb-50">
                          <div className="images-part">
                            <img src="assets/img/Pradeep_1.png" width={150} height={150} alt="images" />
                          </div>
                        </div>
                        <div className="col-lg-9">
                          <div className="con-info">
                            <h4>Pradeep Pasari
                            </h4>
                            <p>Independent Director
                            </p>
                            <div className="short-desc">
                              <p>Pradeep Pasari, is an Independent Director of our Company, appointed to the Board on April 30, 2025. He is a qualified Company Secretary and Chartered Accountant and holds a Bachelor of Commerce degree. He is registered with the Indian Institute of Corporate Affairs as an Independent Director.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="modal fade" id="lokeshModal" tabIndex={-1} aria-labelledby="lokeshModalLabel" aria-hidden="true">
    <div className="modal-dialog ">
      <div className="modal-content modal-xl">
        <div className="modal-header">
          <h5 className="modal-title" id="lokeshModalLabel" />
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          <div className="rs-contact contact-style2 md-pt-70 md-pb-70">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="container custom">
                    <div className="btm-info-team">
                      <div className="row align-items-center">
                        <div className="col-lg-3 md-mb-50">
                          <div className="images-part">
                            <img src="assets/img/lokesh.png" alt="images" />
                          </div>
                        </div>
                        <div className="col-lg-9">
                          <div className="con-info">
                            <h4>Lokesh Ahuja</h4>
                            <p>Director- Sales<br />
                              Advisory Services</p>
                            <div className="ps-informations">
                            </div>
                            <div className="short-desc">
                              <p>Lokesh has 20+ years of experience in business development in retail financial services &amp; real estate. He has previously worked with Indiabulls, SARE group, and ICICI Wealth.  He is driven about process, productivity and profitability, steeped in sincerity, integrity and motivation He is proficient in managing P&amp;L while achieving sustainable growth in revenue and profits.</p>
                              <p />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="modal fade" id="rakeshModal" tabIndex={-1} aria-labelledby="rakeshModalLabel" aria-hidden="true">
    <div className="modal-dialog ">
      <div className="modal-content modal-xl">
        <div className="modal-header">
          <h5 className="modal-title" id="rakeshModalLabel" />
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          <div className="rs-contact contact-style2 md-pt-70 md-pb-70">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="container custom">
                    <div className="btm-info-team">
                      <div className="row align-items-center">
                        <div className="col-lg-3 md-mb-50">
                          <div className="images-part">
                            <img src="assets/img/Anju.png" width={150} height={150} alt="images" />
                          </div>
                        </div>
                        <div className="col-lg-9">
                          <div className="con-info">
                            <h4>Anju
                            </h4>
                            <p>Company Secretary & Compliance Officer
                            </p>
                            <div className="short-desc">
                              <p>Anju is an accomplished Company Secretary and Legal professional with over 7 years of experience in corporate governance, regulatory compliance, and legal affairs. She has worked with reputed organizations such as Stemz Healthcare and Skymet Weather Services.</p>
                              <p>She specializes in managing regulatory filings, contract negotiations, and providing strategic legal counsel to mitigate business risks. Anju holds an LLB degree, is an Associate Company Secretary (ACS), and has earned certifications in Intellectual Property and Commercial Contracts.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="modal fade" id="amitModal" tabIndex={-1} aria-labelledby="amithModalLabel" aria-hidden="true">
    <div className="modal-dialog ">
      <div className="modal-content modal-xl">
        <div className="modal-header">
          <h5 className="modal-title" id="amitModalLabel" />
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          <div className="rs-contact contact-style2 md-pt-70 md-pb-70">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="container custom">
                    <div className="btm-info-team">
                      <div className="row align-items-center">
                        <div className="col-lg-3 md-mb-50">
                          <div className="images-part">
                            <img src="assets/img/kanav.png" alt="images" />
                          </div>
                        </div>
                        <div className="col-lg-9">
                          <div className="con-info">
                            <h4>Kanv Bhalla  </h4>
                            <p>Senior Managerial Personnel </p>
                            <div className="short-desc">
                             <p>Kanv has 15+ years of experience in Business Development and a demonstrated history of working in the real estate industry. He has previously worked in Citi Bank, Yes Bank and later started his own ventures. He is skilled in Business Planning, Sales, Management, and team building. His collaborative abilities make him an excellent leader who can chart his own course independently.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div className="modal fade" id="pradeepModal" tabIndex={-1} aria-labelledby="pradeepModalLabel" aria-hidden="true">
  <div className="modal-dialog ">
    <div className="modal-content modal-xl">
      <div className="modal-header">
        <h5 className="modal-title" id="pradeepModalLabel" />
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
      </div>
      <div className="modal-body">
        <div className="rs-contact contact-style2 md-pt-70 md-pb-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="container custom">
                  <div className="btm-info-team">
                    <div className="row align-items-center">
                      <div className="col-lg-3 md-mb-50">
                        <div className="images-part">
                          <img src="assets/img/Pradeep.png" alt="images" />
                        </div>
                      </div>
                      <div className="col-lg-9">
                        <div className="con-info">
                          <h4>Pradeep Pasari</h4>
                          <p>Independent Director</p>
                          <div className="short-desc">
                              <p>Pradeep Pasari, is an Independent Director of our Company, appointed to the Board on April 30, 2025. He is a qualified Company Secretary and Chartered Accountant and holds a Bachelor of Commerce degree. He is registered with the Indian Institute of Corporate Affairs as an Independent Director.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  <div className="modal fade" id="mandeepModal" tabIndex={-1} aria-labelledby="mandeepModalLabel" aria-hidden="true">
  <div className="modal-dialog ">
    <div className="modal-content modal-xl">
      <div className="modal-header">
        <h5 className="modal-title" id="mandeepModalLabel" />
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
      </div>
      <div className="modal-body">
        <div className="rs-contact contact-style2 md-pt-70 md-pb-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="container custom">
                  <div className="btm-info-team">
                    <div className="row align-items-center">
                      <div className="col-lg-3 md-mb-50">
                        <div className="images-part">
                          <img src="assets/img/gaurav.png" alt="images" />
                        </div>
                      </div>
                      <div className="col-lg-9">
                        <div className="con-info">
                          <h4>Gaurav Bhardwaj</h4>
                          <p>Chief Financial Officer</p>
                          <div className="short-desc">
                 <p>A Banking industry professional with experience of 7+ Years with RBL Bank in their Corporate &amp; Institutional Banking Group. Had scaled up the North India portfolio for financial institutions &amp; government group for RBL Bank from $5 Mn to $400 Mn.
                              </p>
                              <p>Have also worked with ICICI Bank in their SMEAG division. Gaurav is an MBA from IIM Shillong and majored in Finance. He did his Bachelors in Business Studies from Shaheed Sukhdev College of Business Studies, Delhi University.
                              </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</div>

       
            
        


</div>




  )
}

export default Aboutus